import { createI18n } from 'vue-i18n'
import { buildLocaleMessages } from './assemble-messages'

const en = buildLocaleMessages('en')
const zh = buildLocaleMessages('zh')

// 获取浏览器语言或从 localStorage 读取保存的语言设置
const getDefaultLocale = (): string => {
  // 优先从 localStorage 读取
  const savedLocale = localStorage.getItem('ui-locale')
  if (savedLocale && (savedLocale === 'en' || savedLocale === 'zh')) {
    return savedLocale
  }

  // 其次从浏览器语言设置获取
  const browserLang = navigator.language || (navigator as any).userLanguage
  if (browserLang.startsWith('zh')) {
    return 'zh'
  }

  // 默认返回中文（因为这是中文系统）
  return 'zh'
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLocale(), // 默认语言
  fallbackLocale: 'zh', // 回退语言为中文
  messages: {
    en,
    zh,
  },
  globalInjection: true, // 全局注入 $t 函数
  warnHtmlMessage: false, // 禁用 HTML 消息警告
})

export default i18n
